import axios from "../utils/apis/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
	const { setAuth, auth } = useAuth();

	const refresh = async () => {
		const response = await axios.post("/gs1/standard/user/refresh", {
			refreshToken: auth?.refreshToken || "refreshToken is undefined",
		});
		setAuth((prevAuth) => ({
			...prevAuth,
			accessToken: response?.data?.data?.tokens?.accessToken,
			refreshToken: response?.data?.data?.tokens?.refreshToken ?? prevAuth.refreshToken,
		}));
		return response?.data?.data?.tokens?.accessToken;
	};
	return refresh;
};

export default useRefreshToken;
